import { MANUAL_TRANSLATION_AVAILABLE } from '~/config/shared/countryConfig';

export const hasManualTranslationsAlways = (country: string): boolean | undefined => {
  return MANUAL_TRANSLATION_AVAILABLE[country];
};
